module.exports = __webpack_public_path__ + "img/infrustructure.e11b1b7.svg";